import { all, takeLatest } from 'redux-saga/effects';

import {
  CREATE_DE_SUBMISSION_REQUEST,
  CREATE_GB_SUBMISSION_REQUEST,
} from '@constants/action-types/submission';

import { handleCreateDESubmissionSaga } from './handleCreateDESubmissionSaga';
import { handleCreateGbSubmissionSaga } from './handleCreateGBSubmissionSaga';

export default all([
  takeLatest(CREATE_GB_SUBMISSION_REQUEST, handleCreateGbSubmissionSaga),
  takeLatest(CREATE_DE_SUBMISSION_REQUEST, handleCreateDESubmissionSaga),
]);
